import { HEIGHT_MEASUREMENT } from 'productTemplate/enums/fitFeedback';

interface IGetHeightInches {
  measurement: string;
  feet: number;
  inches: number;
  cm: number;
}

export const getHeightInches = ({ measurement, feet, inches, cm }: IGetHeightInches) => {
  if (measurement === HEIGHT_MEASUREMENT.FT) {
    return feet * 12 + inches;
  }
  if (measurement === HEIGHT_MEASUREMENT.CM) {
    return cm * 0.393701;
  }
};

export const getFeetFromInches = (inches: number) => {
  if (typeof inches !== 'number') {
    return;
  }

  return { feet: Math.floor(inches / 12), inches: inches % 12 };
};
